import {
  TRACK_INVITE_FRIENDS,
  TRACK_SHOW_REFERRAL_PROMPT,
  TRACK_INVITE_BANNER_CLOSE,
  TRACK_INVITE_BANNER_CLICK,
  TRACK_INVITE_BANNER_VISIT,
} from './types';

export function trackInvitedFriends(method) {
  return {
    type: TRACK_INVITE_FRIENDS,
    payload: {
      name: 'Invited Friends',
      properties: {
        'Invite method': method,
      },
    },
  };
}

export function trackShowRoovitePrompt({
  promptContext,
  referrerAmount,
  inviteeAmount,
  referralCode,
}) {
  return {
    type: TRACK_SHOW_REFERRAL_PROMPT,
    payload: {
      name: 'Shown Referral Prompt',
      properties: {
        'Prompt context': promptContext,
        'Referrer Amount': referrerAmount,
        'Referral Code': referralCode,
        'Invitee Amount': inviteeAmount,
      },
    },
  };
}

export function trackInviteBannerClose() {
  return {
    type: TRACK_INVITE_BANNER_CLOSE,
    payload: {
      name: 'Mobile MGM Invite Banner dismissed',
      properties: {},
    },
  };
}

export function trackInviteBannerClick() {
  return {
    type: TRACK_INVITE_BANNER_CLICK,
    payload: {
      name: 'Mobile MGM Invite Banner modal opened',
      properties: {},
    },
  };
}

export function trackInviteBannerVisit() {
  return {
    type: TRACK_INVITE_BANNER_VISIT,
    payload: {
      name: 'Mobile MGM Invite Banner displayed',
      properties: {},
    },
  };
}
